'use client';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import PropTypes from 'prop-types';

import { getQueryClient } from '@/lib/get-query-client';

const ReactQueryClientProvider = ({ children }) => {
	const queryClient = getQueryClient();

	return (
		<QueryClientProvider client={queryClient}>
			{children}
			<ReactQueryDevtools initialIsOpen={false} />
		</QueryClientProvider>
	);
};

ReactQueryClientProvider.propTypes = {
	children: PropTypes.node.isRequired
};

export default ReactQueryClientProvider;
